import React from 'react';

import StyledComponent from './styles';

export enum Parts {
    Default = 'default',
    Back = 'back',
    Buttocks = 'buttocks',
    Armpits = 'armpits',
    Face = 'face',
    NeckAndShoulders = 'neckAndShoulders',
    Bikini = 'bikini',
    Chest = 'chest',
    Calves = 'calves',
    Feet = 'feet',
    Hands = 'hands',
    Thighs = 'thighs',
    Tummy = 'tummy',
    Arms = 'arms',
    Mustache = 'mustache',
    Chin = 'chin',
    Palm = 'palm',
    WhiteLine = 'whiteLine',
}

export enum Side {
    Left = 'left',
    Right = 'right',
    Default = 'default',
}

export type BodyPart<Part> = Part;

interface Props {
    bodyPart: BodyPart<Parts>
    zoomIn: Boolean;
}

export default function PublicInteractiveBodyManModuleRenderSilhouette(props: Props): JSX.Element {
    const { bodyPart, zoomIn } = props;

    const parts = {
        default: {
            fullFrame: '/images/weman-zone/interactive-body/body-parts/jpg/fullframe-new/woman_premium_b_w.jpg',
            zoomedIn: '/images/weman-zone/interactive-body/body-parts/jpg/fullframe-new/woman_premium_b_w.jpg',
        },
        back: {
            fullFrame: '/images/weman-zone/interactive-body/body-parts/jpg/fullframe-new/back.jpg',
            zoomedIn: '/images/weman-zone/interactive-body/body-parts/jpg/fullframe-new/back.jpg',
        },
        buttocks: {
            fullFrame: '/images/weman-zone/interactive-body/body-parts/jpg/fullframe-new/buttocks.jpg',
            zoomedIn: '/images/weman-zone/interactive-body/body-parts/jpg/fullframe-new/buttocks.jpg',
        },
        armpits: {
            fullFrame: '/images/weman-zone/interactive-body/body-parts/jpg/fullframe-new/armpits.jpg',
            zoomedIn: '/images/weman-zone/interactive-body/body-parts/jpg/fullframe-new/armpits.jpg',
        },
        face: {
            fullFrame: '/images/weman-zone/interactive-body/body-parts/jpg/fullframe-new/face.jpg',
            zoomedIn: '/images/weman-zone/interactive-body/body-parts/jpg/fullframe-new/face.jpg',
        },
        bikini: {
            fullFrame: '/images/weman-zone/interactive-body/body-parts/jpg/fullframe-new/bikini.jpg',
            zoomedIn: '/images/weman-zone/interactive-body/body-parts/jpg/fullframe-new/bikini.jpg',
        },
        calves: {
            fullFrame: '/images/weman-zone/interactive-body/body-parts/jpg/fullframe-new/woman_premium_calves.jpg',
            zoomedIn: '/images/weman-zone/interactive-body/body-parts/jpg/fullframe-new/woman_premium_calves.jpg',
        },
        thighs: {
            fullFrame: '/images/weman-zone/interactive-body/body-parts/jpg/fullframe-new/woman_premium_thighs.jpg',
            zoomedIn: '/images/weman-zone/interactive-body/body-parts/jpg/fullframe-new/woman_premium_thighs.jpg',
        },
        tummy: {
            fullFrame: '/images/weman-zone/interactive-body/body-parts/jpg/fullframe-new/woman_premium_tummy.jpg',
            zoomedIn: '/images/weman-zone/interactive-body/body-parts/jpg/fullframe-new/woman_premium_tummy.jpg',
        },
        hands: {
            fullFrame: '/images/weman-zone/interactive-body/body-parts/jpg/fullframe-new/hands.jpg',
            zoomedIn: '/images/weman-zone/interactive-body/body-parts/jpg/fullframe-new/hands.jpg',
        },
        arms: {
            fullFrame: '/images/weman-zone/interactive-body/body-parts/jpg/fullframe-new/arms.jpg',
            zoomedIn: '/images/weman-zone/interactive-body/body-parts/jpg/fullframe-new/arms.jpg',
        },
        feet: {
            fullFrame: '/images/weman-zone/interactive-body/body-parts/jpg/fullframe-new/feet.jpg',
            zoomedIn: '/images/weman-zone/interactive-body/body-parts/jpg/fullframe-new/feet.jpg',
        },
        mustache: {
            fullFrame: '/images/weman-zone/interactive-body/body-parts/jpg/fullframe-new/mustache.jpg',
            zoomedIn: '/images/weman-zone/interactive-body/body-parts/jpg/fullframe-new/mustache.jpg',
        },
        chin: {
            fullFrame: '/images/weman-zone/interactive-body/body-parts/jpg/fullframe-new/chin.jpg',
            zoomedIn: '/images/weman-zone/interactive-body/body-parts/jpg/fullframe-new/chin.jpg',
        },
        palm: {
            fullFrame: '/images/weman-zone/interactive-body/body-parts/jpg/fullframe-new/palm.jpg',
            zoomedIn: '/images/weman-zone/interactive-body/body-parts/jpg/fullframe-new/palm.jpg',
        },
        whiteLine: {
            fullFrame: '/images/weman-zone/interactive-body/body-parts/jpg/fullframe-new/white_line.jpg',
            zoomedIn: '/images/weman-zone/interactive-body/body-parts/jpg/fullframe-new/white_line.jpg',
        },
    };

    const getSelectedBodyPartImagePath = () => {
        let imgType = 'fullFrame';

        if (zoomIn) {
            imgType = 'zoomedIn';
        }

        return (parts[bodyPart] && parts[bodyPart][imgType]) || parts[Parts.Default].fullFrame;
    };

    return (
        <StyledComponent className={`public-interactive-body-woman-module-render-silhouette ${bodyPart}`}>
            <img
                className="silhouette-image"
                src={getSelectedBodyPartImagePath()}
                loading='lazy'
            />
        </StyledComponent>
    );
}
